const FocusOnPatientCareIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2942_142272)">
        <g clipPath="url(#clip1_2942_142272)">
          <path
            d="M32 63C49.1208 63 63 49.1208 63 32C63 14.8792 49.1208 1 32 1C14.8792 1 1 14.8792 1 32C1 49.1208 14.8792 63 32 63Z"
            stroke="#027C80"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M32.0001 60.0085C47.4707 60.0085 60.0121 47.4671 60.0121 31.9964C60.0121 16.5258 47.4707 3.98438 32.0001 3.98438C16.5295 3.98438 3.98804 16.5258 3.98804 31.9964C3.98804 47.4671 16.5295 60.0085 32.0001 60.0085Z"
            stroke="#027C80"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M41.6112 30.5781C42.1416 31.2616 42.4578 32.1219 42.4578 33.0556C42.4578 35.2904 40.6463 37.1018 38.4116 37.1018C37.8277 37.1018 37.2725 36.9786 36.772 36.7557"
            stroke="#FFA473"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M32.0623 44.5684C33.8538 44.5684 36.0571 38.6489 36.5912 37.1351C36.6145 37.0691 36.712 37.0865 36.712 37.1565V40.6131C36.712 41.0363 36.9997 41.4053 37.4102 41.5084L43.1717 42.9561C46.265 43.7333 48.4337 46.5143 48.4337 49.7038V51.0173"
            stroke="#06AEB3"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.9999 44.5606C30.2152 44.5606 28.0203 38.6411 27.4882 37.1273C27.465 37.0613 27.3679 37.0787 27.3679 37.1487V40.6052C27.3679 41.0285 27.0812 41.3975 26.6723 41.5006L20.9327 42.9482C17.8511 43.7255 15.6907 46.5065 15.6907 49.696V51.0095"
            stroke="#06AEB3"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.2268 25.1501C22.2268 25.1501 31.5844 25.8294 35.7761 21.1328C35.7761 21.1328 37.9758 24.8198 41.8352 24.8198"
            stroke="#FFA473"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M41.778 21.8438C41.8166 22.1799 41.8352 22.521 41.8352 22.8659V28.5604C41.8352 33.6225 37.7305 37.7271 32.6685 37.7271H31.3936C26.3315 37.7271 22.2268 33.6225 22.2268 28.5604V22.8659C22.2268 22.521 22.2455 22.1799 22.2841 21.8438"
            stroke="#FFA473"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.2268 23.1641C22 18 26.3315 15 31.3935 15H32.6684C37.7305 15 42 18 41.8352 23.1641"
            stroke="#FFA473"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.4412 41.8125C25.4412 41.8125 27.6256 48.3255 31.9915 48.3255C36.3574 48.3255 38.612 41.8125 38.612 41.8125"
            stroke="#06AEB3"
            strokeWidth="1.2"
            strokeMiterlimit="10"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2942_142272">
          <rect
            width="64"
            height="64"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_2942_142272">
          <rect
            width="64"
            height="64"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FocusOnPatientCareIcon;
